import React from "react";
import { Switch, useRouteMatch } from "react-router-dom";
import PrivateRoute from "../../../../Routes/PrivateRoutes";
import CampanhaProvider from "./CampanhaContext";
import PesquisarCampanha from "./Events/PesquisarCampanha";
import FormularioCampanha from "./Events/FormularioCampanha";

const Index = () => {
  let match = useRouteMatch();
  return (
    <CampanhaProvider>
      <div className="container-fluid pl-3 pt-3 pb-3">
        <Switch>
          <PrivateRoute
            exact
            path={`${match.url}`}
            component={PesquisarCampanha}
          />
          <PrivateRoute
            exact
            path={`${match.url}/:id`}
            component={FormularioCampanha}
          />
          <PrivateRoute
            exact
            path={`${match.url}/:id/:processo`}
            component={FormularioCampanha}
          />
        </Switch>
      </div>
    </CampanhaProvider>
  );
};

export default Index;
